import script from "./ServiceSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSetup.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSetup.vue?vue&type=style&index=0&id=5a7905ec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7905ec"]])

export default __exports__